import { ErrorDeLaApi, pedir } from './nucleo'

/**
 * La vista previa de lo que todavía no está publicado (plan del CMS dinámico §15): un
 * documento en borrador en su dirección, un tipo o una taxonomía con su plantilla sin
 * publicar, o la estructura entera pendiente. La dirección la da el núcleo
 * (`POST /api/previas`): lleva un testigo firmado que dura unos minutos y solo abre lo pedido.
 * El panel no compone ninguna.
 */
export type AlcanceDePrevia =
  | { alcance: 'documento'; documento: { coleccion: string; id: number } }
  | { alcance: 'tipo'; documento: { coleccion: 'taxonomias' | 'tipos-de-contenido'; id: number } }
  | { alcance: 'estructura' }

export type Previa = { url: string; caduca: string }

/** Las colecciones cuyos documentos se previsualizan en su dirección (lo que el núcleo admite con `alcance: 'documento'`). */
export const COLECCIONES_CON_PREVIA = new Set(['paginas', 'entradas', 'productos', 'servicios', 'contenidos'])

export const pedirPrevia = (sitio: number, que: AlcanceDePrevia): Promise<Previa> => pedir<Previa>('/previas', { metodo: 'POST', cuerpo: { sitio, ...que } })

/** Lo que se le dice a quien pidió la previa si no sale. El núcleo escribe sus mensajes en llano; si no dice nada, esto. */
export const mensajeDeLaPrevia = (e: unknown): string => {
  if (e instanceof ErrorDeLaApi) {
    if (e.status === 409 && !e.message) return 'Ese documento todavía no tiene dirección: ponle una y guarda antes de verlo.'
    return e.message || 'No se ha podido preparar la vista previa. Vuelve a intentarlo.'
  }
  return 'No se ha podido preparar la vista previa. Vuelve a intentarlo.'
}

/**
 * Pide la previa y la abre en una pestaña nueva. La pestaña se abre **antes** de pedirla, en el
 * mismo clic: un navegador bloquea las ventanas que se abren después de esperar a la red. Si el
 * núcleo dice que no, se cierra y se devuelve el mensaje.
 */
export const abrirPrevia = async (sitio: number, que: AlcanceDePrevia): Promise<null | string> => {
  const pestana = typeof window !== 'undefined' ? window.open('', '_blank') : null
  try {
    const { url } = await pedirPrevia(sitio, que)
    if (pestana) {
      // La previa no tiene por qué poder tocar el panel.
      pestana.opener = null
      pestana.location.href = url
    } else window.open(url, '_blank', 'noopener')
    return null
  } catch (e) {
    pestana?.close()
    return mensajeDeLaPrevia(e)
  }
}
